import { useEffect, useState } from "react";
import FeedStruct from '../utils/FeedStruct';
import FeedRefresh from "./FeedRefresh";

export default function useFeed (  )
{
  /* 2026 :: WIP
   * price update timer.
   * time will be setup using the service last update datetime
   * in the best case scenario */
  const [ timer, set_timer ] = useState( '00 : 00' );
  const [ feed, set_current_feed ] = useState({  }); // feed container.
  const [ error, set_error ] = useState({  });

  const currentFeed = FeedStruct({});
  const delay = 5 ; // minutes




  useEffect( () => {

    // TEMP:
    // forcing update regardless of time passed for now
    FeedRefresh( 1 ).then( re => {
      set_current_feed( re );
    }).catch( er => {
      console.error(er);
    });

    // start interval
    let tt = setInterval(() => {

      console.log( 'feed ticking...' );
      FeedRefresh( delay ).then( re => {
        set_current_feed( re );
      }).catch( er => {
        console.error(er);
      });

    }, delay * 60000 );

    // stop timer on component exit.
    // avoid timer start loops.
    return () => {
      clearInterval( tt );
    };
  }, [  ] );

  return { feed, error };

  function format_time ( time ) {
    let T = new Date( time );
    return T.toLocaleString("en-GB", { timeZone: "+02:00" });
  }

}
